(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[788],{

/***/ 2720:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/launch",
      function () {
        return __webpack_require__(6480);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



var Footer = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-zinc-800",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "mx-auto flex max-w-7xl flex-col justify-center px-8 pt-12 pb-6 font-kr text-zinc-100 md:px-16",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col justify-between md:flex-row md:space-x-16",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "block",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-36 pb-10 hover:cursor-pointer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/assets/ocena_logo_white.png",
                                        className: "w-full",
                                        alt: "ocena logo"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col items-start justify-end space-y-5 md:flex-row md:space-y-0 md:space-x-12",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex w-1/2 flex-col",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "px-1 py-2 text-base font-medium",
                                            children: "서비스"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                            className: "width-[1px] w-40 border-zinc-600 md:w-32"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex flex-col space-y-3 px-1 py-5",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: "/launch",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: "whitespace-nowrap font-light",
                                                    children: "오세나 사용하기"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex w-1/2 flex-col",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "px-1 py-2 text-base font-medium",
                                            children: "팀"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                            className: "width-[1px] w-40 border-zinc-600 md:w-32"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-col space-y-3 px-1 py-5",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                    href: "/contact",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        className: "whitespace-nowrap font-light",
                                                        children: "문의하기"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "https://www.linkedin.com/company/ocena-app",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    className: "whitespace-nowrap font-light",
                                                    children: "링크드인"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                    href: "https://blog.ocena.app",
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        className: "whitespace-nowrap font-light",
                                                        children: "블로그"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex space-x-3 pt-16",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs font-light text-zinc-400",
                            children: "\xa9 Copyright 2023 ocena"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs font-light text-zinc-400",
                            children: "|"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "text-xs font-light text-zinc-400",
                            href: "mailto: contact@ocena.app",
                            children: "contact@ocena.app"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 4001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2920);
/* harmony import */ var react_toastify_dist_ReactToastify_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(993);
/* harmony import */ var react_toastify_dist_ReactToastify_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_toastify_dist_ReactToastify_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _LandingAnimation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(273);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);





var CTA = function() {
    return(// <LandingAnimation>
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute inset-0 z-0 h-56 w-full rounded-[1.75rem] border-[3px] border-zinc-700 bg-zinc-700 sm:h-64 md:h-72 "
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "z-100 flex h-56 w-full translate-y-[-5px] translate-x-[-5px] flex-col justify-between rounded-[1.75rem] border-[3px] border-zinc-700 bg-white p-8 text-lg font-bold sm:h-64 sm:px-10 sm:pb-10 sm:pt-12 md:h-72 md:pt-16 ",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                            className: "text-xl font-bold sm:text-2xl md:text-3xl lg:text-4xl",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: " underline decoration-primary/60 decoration-4 underline-offset-0 md:decoration-8",
                                    children: "오세나"
                                }),
                                "와 함께 반복적인 ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                                    className: " md:hidden"
                                }),
                                "영업지원 업무를 끝내세요"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex w-full justify-end space-x-1",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    className: "",
                                    href: "/contact",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "hidden rounded-full border-[3px] border-zinc-100 px-5 py-4 text-sm font-bold transition-all hover:border-zinc-500 hover:bg-zinc-100 sm:block md:px-7 md:text-base",
                                        children: "데모 요청하기"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    href: "/launch",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "rounded-full border-[3px] border-primary/80 px-5 py-4 text-sm font-bold transition-all hover:border-primary/10 hover:bg-primary/50 md:px-7 md:text-base",
                                        children: "출시 사전신청"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CTA);


/***/ }),

/***/ 273:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



var LandingAnimation = function(param) {
    var children = param.children;
    var ref = useRef(null);
    var isInView = useInView(ref, {
        once: true
    });
    return /*#__PURE__*/ _jsx(motion.div, {
        ref: ref,
        style: {
            transform: isInView ? "none" : "translateY(50px)",
            opacity: isInView ? 1 : 0,
            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"
        },
        children: children
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (LandingAnimation)));


/***/ }),

/***/ 5083:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2920);
/* harmony import */ var react_toastify_dist_ReactToastify_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(993);
/* harmony import */ var react_toastify_dist_ReactToastify_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_toastify_dist_ReactToastify_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _LandingAnimation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(273);




var Share = function() {
    var shareKakao = function() {
        window.Kakao.Share.sendCustom({
            templateId: 84118
        });
    };
    return /*#__PURE__*/ _jsx(LandingAnimation, {
        children: /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx("div", {
                className: "flex justify-center pb-8",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "m-4 flex min-h-[350px] flex-col justify-center space-y-16 rounded-md bg-primary/80 p-10 md:m-10 md:max-w-5xl md:flex-row md:space-x-16 md:space-y-0 md:p-12",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "font-kr text-4xl font-bold leading-normal text-zinc-900 md:basis-[45%]",
                            children: "오세나가 필요한 지인이 있나요?"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "md: flex basis-[65%] flex-col justify-between space-y-6 md:p-1",
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    className: "font-kr text-lg font-normal leading-normal text-zinc-900 md:content-start lg:text-xl",
                                    children: "지인의 업무효율을 한단계 업그레이드 시켜줄 오세나 견적서 제작 툴을 소개해주세요."
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex space-x-4",
                                    children: [
                                        /*#__PURE__*/ _jsx("button", {
                                            className: "flex h-11 w-11 items-center justify-center rounded-full bg-zinc-800",
                                            onClick: function() {
                                                navigator.clipboard.writeText("https://ocena.app");
                                                toast("링크가 복사되었습니다.", {
                                                    toastId: "오세나 LINK_COPIED"
                                                });
                                            },
                                            children: /*#__PURE__*/ _jsx("img", {
                                                src: "/assets/link_icon.png",
                                                className: "w-7",
                                                alt: "copy link icon"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("button", {
                                            onClick: shareKakao,
                                            className: "flex h-11 w-11 items-center justify-center rounded-full bg-zinc-800",
                                            children: /*#__PURE__*/ _jsx("img", {
                                                src: "/assets/kakao_logo.png",
                                                className: "w-6",
                                                alt: "share to Kakao Talk icon"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("a", {
                                            href: "https://www.linkedin.com/company/ocena-app",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "flex h-11 w-11 items-center justify-center rounded-full bg-zinc-800",
                                            children: /*#__PURE__*/ _jsx("img", {
                                                src: "/assets/linkedin_logo.png",
                                                className: "w-5",
                                                alt: "share to Linkedin icon"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("a", {
                                            href: "https://www.instagram.com/ocena.app/",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "flex h-11 w-11 items-center justify-center rounded-full bg-zinc-800",
                                            children: /*#__PURE__*/ _jsx("img", {
                                                src: "/assets/instagram_logo.png",
                                                className: "w-6",
                                                alt: "link_icon"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Share)));


/***/ }),

/***/ 6480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ launch; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/Footer.js
var Footer = __webpack_require__(3193);
// EXTERNAL MODULE: ./components/landingpage/CTA.js
var CTA = __webpack_require__(4001);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./components/landingpage/Share.js
var Share = __webpack_require__(5083);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Navbar.js
var Navbar = __webpack_require__(8010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./contexts/FirebaseContext.js
var FirebaseContext = __webpack_require__(6239);
// EXTERNAL MODULE: ./node_modules/firebase/storage/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(1153);
// EXTERNAL MODULE: ./firebase/firebase.js + 3 modules
var firebase = __webpack_require__(1212);
;// CONCATENATED MODULE: ./firebase/firebaseLaunch.js




var LAUNCH_COLLECTION = "launch";
var saveLaunchEmail = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(launchEmail) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,index_esm.addDoc)((0,index_esm.collection)(firebase.db, LAUNCH_COLLECTION), {
                        email: launchEmail
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function saveLaunchEmail(launchEmail) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./firebase/whitelist.js
var whitelist = __webpack_require__(779);
;// CONCATENATED MODULE: ./pages/launch.js
















var Launch = function() {
    var router = (0,next_router.useRouter)();
    var auth = (0,react.useContext)(FirebaseContext/* FirebaseContext */.f).auth;
    var ref = (0,react.useState)(false), dataLoaded = ref[0], setDataLoaded = ref[1];
    var ref1 = (0,react.useState)(""), launchEmail = ref1[0], setLaunchEmail = ref1[1];
    var emailSubmitClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        _ctx.next = 3;
                        return (0,whitelist/* addLaunchEmail */.ks)(launchEmail);
                    case 3:
                        _ctx.next = 5;
                        return router.push({
                            pathname: "/launch-thankyou",
                            query: {
                                email: launchEmail
                            }
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function emailSubmitClick(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "ocena | 오세나 론칭"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/assets/favicon.ico"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "prefinery-script",
                src: "https://widget.prefinery.com/widget/v2/qtvascno.js",
                defer: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " h-full w-full scroll-smooth bg-white font-kr text-zinc-700 selection:bg-zinc-700 selection:text-zinc-100 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative bg-cust_blue",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/icon-stamp.png",
                                alt: "stamp icon",
                                className: "absolute right-0 top-5 w-1/2 max-w-[16rem] md:w-1/3 lg:top-10 lg:right-12 lg:w-64 xl:right-24 xl:w-80"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/icon-heart.png",
                                alt: "heart icon",
                                className: "absolute left-10 bottom-0 w-52 md:bottom-10 lg:bottom-20 lg:left-16 xl:left-24 xl:bottom-40 "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-[url('/assets/noise.png')] bg-repeat backdrop-brightness-95",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mx-auto max-w-[83rem] items-center justify-center px-4 pt-40 pb-28 md:px-8 lg:flex lg:space-x-20 lg:pb-40 lg:pt-48",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex w-full flex-col items-center justify-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                className: "whitespace-nowrap text-center text-5xl font-bold leading-snug text-white lg:text-6xl xl:leading-normal ",
                                                children: [
                                                    "프로덕트 출시 ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                        className: "md:hidden"
                                                    }),
                                                    "사전신청"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "mt-6 w-full max-w-lg whitespace-normal text-center text-white lg:text-lg",
                                                children: [
                                                    "단 한 번의 거래 정보 입력으로 견적서, 세금계산서, 거래명세서,",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                        className: "hidden md:block"
                                                    }),
                                                    "정산관리 등 번거로운 영업지원 업무를 한 번에 처리하세요."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                                className: "flex w-full flex-col",
                                                onSubmit: function(e) {
                                                    emailSubmitClick(e);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "mt-10 flex flex-col items-center justify-center space-y-6 space-x-3 md:flex-row md:space-y-0",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "flex w-full flex-col items-center px-4 md:w-auto md:px-0 ",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    required: true,
                                                                    id: "user-email",
                                                                    type: "email",
                                                                    placeholder: "tom@example.com",
                                                                    className: "h-[4.5rem] w-full max-w-[25rem] rounded-full border-4 border-white px-7 font-medium text-cust_blue transition-all focus:border-4 focus:border-red-400 focus:outline-none md:w-[20rem] md:max-w-none ",
                                                                    onChange: function(e) {
                                                                        setLaunchEmail(e.target.value);
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "relative ",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "absolute inset-0 z-0 flex h-[4.5rem] w-[10rem] items-center justify-center rounded-full border-[3px] border-zinc-600 bg-zinc-600 "
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                        value: "사전신청하기",
                                                                        type: "submit",
                                                                        className: "z-100 flex h-[4.5rem] w-[10rem] items-center justify-center rounded-full border-[3px] border-white bg-[#FF3B30] text-lg font-bold text-white transition-all duration-150 ease-in-out will-change-transform hover:translate-y-[-4px] hover:translate-x-[-2px] hover:cursor-pointer focus:translate-y-[-1px] focus:translate-x-[-1px] focus:bg-zinc-300 active:duration-100 "
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: " mt-4 flex items-center justify-center ",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                id: "link-checkbox",
                                                                type: "checkbox",
                                                                value: "",
                                                                required: true,
                                                                className: "h-4 w-4 rounded-xl hover:cursor-pointer"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                className: "ml-2 text-sm font-medium text-zinc-300 ",
                                                                children: [
                                                                    "만 14세 이상임을 확인하고, \xa0",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/terms",
                                                                        className: "hover:underline",
                                                                        children: "개인정보 수집 및 이용"
                                                                    }),
                                                                    "에 동의합니다."
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "z-100 absolute bottom-0 h-3 w-full rotate-180",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-full w-full bg-[url('/assets/segment.png')] bg-contain bg-repeat-x"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative mx-auto w-full max-w-7xl bg-white px-4 py-8 md:px-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "inline-flex w-full flex-nowrap overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-200px),transparent_100%)]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "flex animate-infinite-scroll items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-h-10 [&_img]:max-w-[10rem]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/AK.png",
                                                alt: "AK",
                                                className: " "
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/stepping.png",
                                                alt: "stepping",
                                                className: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/indigo.png",
                                                alt: "indigo",
                                                className: " pt-1"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/fleetune.png",
                                                alt: "fleetune",
                                                className: "w-[9rem] "
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/jober.png",
                                                alt: "jober",
                                                className: "pt-1 "
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/meissa.png",
                                                alt: "meissa",
                                                className: "h-9 "
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/daytrip.png",
                                                alt: "daytrip",
                                                className: "h-9 pt-1"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/relate.png",
                                                alt: "relate",
                                                className: "h-7 "
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/safetics.png",
                                                alt: "safetics",
                                                className: "h-7 "
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/searchfi.png",
                                                alt: "searchfi",
                                                className: " "
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/2080.png",
                                                alt: "2080",
                                                className: " "
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "flex animate-infinite-scroll items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-h-10 [&_img]:max-w-[10rem]",
                                    "aria-hidden": "true",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/AK.png",
                                                alt: "AK",
                                                className: " "
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/stepping.png",
                                                alt: "stepping",
                                                className: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/indigo.png",
                                                alt: "indigo",
                                                className: " pt-1"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/fleetune.png",
                                                alt: "fleetune",
                                                className: "w-[9rem] "
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/jober.png",
                                                alt: "jober",
                                                className: "pt-1 "
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/meissa.png",
                                                alt: "meissa",
                                                className: "h-9 "
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/daytrip.png",
                                                alt: "daytrip",
                                                className: "h-9 pt-1"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/relate.png",
                                                alt: "relate",
                                                className: "h-7 "
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/safetics.png",
                                                alt: "safetics",
                                                className: "h-7 "
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/searchfi.png",
                                                alt: "searchfi",
                                                className: " "
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/customer_logos/2080.png",
                                                alt: "2080",
                                                className: " "
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute z-10 h-3 w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-full w-full bg-[url('/assets/segment.png')] bg-contain bg-repeat-x"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " bg-cust_yellow px-4 pt-20 pb-20 text-cust_blue md:px-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mx-auto flex flex-col items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    className: "whitespace-normal text-center text-3xl font-bold leading-normal md:whitespace-nowrap md:text-4xl ",
                                    children: [
                                        "번거로운 영업지원 ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                            className: "md:hidden"
                                        }),
                                        " 업무가 간단해집니다"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mx-auto mt-14 flex w-full max-w-[65rem] flex-col justify-center space-y-14 md:flex-row md:space-y-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: " w-full justify-between lg:flex lg:space-x-32",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex w-full flex-col items-center justify-center ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/icon-quote.png",
                                                    alt: "오세나 세일스보드 적용 영업 프로세스",
                                                    className: "mt-6 w-40"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: " mt-8 whitespace-nowrap text-xl font-bold leading-snug lg:text-2xl",
                                                    children: "01 견적서"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: " mt-6 whitespace-nowrap text-center text-lg font-normal leading-snug text-zinc-500 ",
                                                    children: [
                                                        "쉽고 빠르게 ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        " 견적서를 만드세요"
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: " w-full justify-between lg:flex lg:space-x-32",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex w-full flex-col items-center justify-center ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/icon-billing.png",
                                                    alt: "오세나 세일스보드 적용 영업 프로세스",
                                                    className: "mt-6 w-40"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: " mt-8 whitespace-nowrap text-xl font-bold leading-snug lg:text-2xl",
                                                    children: "02 정산 관리"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: " mt-6 whitespace-nowrap text-center text-lg font-normal leading-snug text-zinc-500",
                                                    children: [
                                                        "복잡한 거래 조건에 대한 ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        " 정산 관리를 쉽게 처리하세요"
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: " w-full justify-between lg:flex lg:space-x-32",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex w-full flex-col items-center justify-center ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/icon-tax.png",
                                                    alt: "오세나 세일스보드 적용 영업 프로세스",
                                                    className: "mt-6 w-40"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: " mt-8 whitespace-nowrap text-xl font-bold leading-snug lg:text-2xl",
                                                    children: "03 세금계산서"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: " mt-6 whitespace-nowrap text-center text-lg font-normal leading-snug text-zinc-500",
                                                    children: [
                                                        "클릭 한번으로 ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        " 세금계산서를 발행하세요"
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-20 flex w-full justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute inset-0 z-0 flex h-[4.5rem] w-[12.5rem] items-center justify-center rounded-full border-[3px] border-zinc-400 bg-zinc-400 "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: function(e) {
                                                router.push("/");
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "z-100 flex h-[4.5rem] w-[12.5rem] translate-y-[-4px] translate-x-[-2px] items-center justify-center rounded-full border-[3px] border-zinc-500 bg-white text-lg font-bold text-cust_blue transition-all duration-150 ease-in-out will-change-transform hover:translate-y-0 hover:translate-x-0 hover:bg-white focus:translate-y-[-1px] focus:translate-x-[-1px] focus:bg-zinc-300 active:duration-100 ",
                                                children: "더 알아보기 \xa0 →"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var launch = (Launch);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,8010,9774,2888,179], function() { return __webpack_exec__(2720); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);